import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Csv: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3654)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M25.1563 40.4688C24.2813 40.4688 23.625 40.9062 23.1875 41.5625C22.75 42.2188 22.5313 43.0938 22.5313 44.1875C22.5313 46.5938 23.4063 47.6875 25.375 47.6875C26.0313 47.6875 26.4688 47.6875 26.9063 47.4688C27.3438 47.25 28 47.0312 28.4375 46.8125V49.6563C27.3438 50.0938 26.25 50.3125 24.9375 50.3125C22.9687 50.3125 21.6562 49.875 20.5625 48.5625C19.4687 47.25 19.0312 45.9375 19.0312 43.75C19.0312 42.4375 19.25 41.3437 19.6875 40.25C20.125 39.1562 20.7813 38.5 21.875 38.0625C22.9688 37.625 23.8438 37.1875 25.1563 37.1875C26.4688 37.1875 27.7813 37.4062 29.0938 38.0625L28 40.6875C27.5625 40.4688 27.125 40.25 26.6875 40.25C26.25 40.25 25.5938 40.4688 25.1563 40.4688Z"
          fill="white"
        />
        <path
          d="M39.1562 46.5938C39.1562 47.4688 38.9375 48.125 38.5 48.5625C38.0625 49 37.625 49.6562 36.75 49.875C35.875 50.0938 35.2188 50.3125 34.125 50.3125C33.25 50.3125 32.5938 50.3125 31.9375 50.0938C31.2813 49.875 30.8438 49.875 30.1875 49.4375V46.375C30.8438 46.8125 31.5 47.0313 32.1562 47.25C32.8125 47.4688 33.4688 47.4688 34.125 47.4688C34.5625 47.4688 35 47.4688 35.2188 47.25C35.4375 47.0313 35.6562 46.8125 35.6562 46.5938C35.6562 46.375 35.6563 46.375 35.4375 46.1563C35.2188 45.9375 35.2187 46.1563 35 45.9375C34.7812 45.7188 34.3437 45.5 33.25 45.0625C32.375 44.625 31.7187 44.4063 31.5 43.9688C31.2812 43.5313 30.8437 43.3125 30.625 42.875C30.4062 42.4375 30.4062 42 30.4062 41.3438C30.4062 40.25 30.8437 39.375 31.7187 38.7188C32.5937 38.0625 33.6875 37.8438 35.2188 37.8438C36.5313 37.8438 37.8437 38.0625 39.1562 38.7188L38.0625 41.3438C36.9687 40.9063 35.875 40.4688 35 40.4688C34.5625 40.4688 34.3438 40.4688 34.125 40.6875C33.9063 40.9063 33.9062 41.125 33.9062 41.3438C33.9062 41.5625 34.125 41.7813 34.3437 42C34.5625 42.2188 35.2188 42.4375 36.3125 43.0938C37.4063 43.5313 38.0625 44.1875 38.5 44.625C38.9375 45.0625 39.1562 45.7188 39.1562 46.5938Z"
          fill="white"
        />
        <path
          d="M48.125 37.8438H51.8438L47.6875 50.3125H43.75L39.5938 37.8438H43.3125L45.0625 44.1875C45.5 45.5 45.5 46.5938 45.7187 47.0313C45.7187 46.5938 45.9375 46.1562 45.9375 45.5C45.9375 44.8438 46.1562 44.4063 46.1562 44.1875L48.125 37.8438Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
